(function () {
  // Aynı anda kaç sayfa önceden yüklensin (mevcut sayfanın öncesi/sonrası)
  var PRELOAD = 4;

  function initFlipbook(root) {
    if (root.dataset.fbReady) return;
    var bookEl = root.querySelector('[data-fb-book]');
    if (!bookEl || !window.St || !window.St.PageFlip) return;
    root.dataset.fbReady = '1';

    var pages = Array.prototype.slice.call(bookEl.querySelectorAll('.flipbook__page'));
    var imgs = pages.map(function (p) {
      return p.querySelector('img');
    });
    var total = pages.length;
    var counter = root.querySelector('[data-fb-counter]');
    var thumbsPanel = root.querySelector('[data-fb-thumbs-panel]');
    var thumbsGrid = root.querySelector('[data-fb-thumbs-grid]');

    function load(i) {
      var img = imgs[i];
      if (img && !img.getAttribute('src') && img.dataset.src) img.src = img.dataset.src;
    }

    function preloadAround(i) {
      for (var k = i - PRELOAD; k <= i + PRELOAD + 1; k++) {
        if (k >= 0 && k < total) load(k);
      }
    }

    // Başlangıç sayfası: heyzine gibi #page/5 destekle
    var start = 0;
    var m = location.hash.match(/page\/(\d+)/);
    if (m) start = Math.min(Math.max(parseInt(m[1], 10) - 1, 0), total - 1);
    preloadAround(start);

    var pageFlip = new St.PageFlip(bookEl, {
      width: 620,
      height: 877,
      size: 'stretch',
      minWidth: 280,
      maxWidth: 1240,
      minHeight: 396,
      maxHeight: 1754,
      showCover: true,
      usePortrait: true,
      startPage: start,
      maxShadowOpacity: 0.4,
      mobileScrollSupport: true,
      flippingTime: 700,
    });
    pageFlip.loadFromHTML(pages);

    function label(i) {
      if (pageFlip.getOrientation() === 'landscape' && i > 0 && i < total - 1) {
        // showCover ile sol sayfa tek indeksli olur
        var left = i % 2 === 1 ? i : i - 1;
        return left + 1 + '-' + Math.min(left + 2, total) + ' / ' + total;
      }
      return i + 1 + ' / ' + total;
    }

    // Kapak (sadece sağ sayfa) ve tek kalan arka kapak (sadece sol sayfa) ekranın ortasında dursun
    var stage = bookEl.parentElement;
    function center(i) {
      var shift = 0;
      if (pageFlip.getOrientation() === 'landscape') {
        var pw = pageFlip.getRender ? pageFlip.getRender().getRect().pageWidth : bookEl.clientWidth / 2;
        if (i === 0) shift = -pw / 2;
        else if (i === total - 1 && total % 2 === 0) shift = pw / 2;
      }
      stage.style.transform = shift ? 'translateX(' + shift + 'px)' : '';
    }

    // Kapak açılırken/kapanırken kaydırmayı çevirme başında kaldır, bitince yeniden hesapla
    pageFlip.on('changeState', function (e) {
      if (e.data === 'flipping' || e.data === 'user_fold') {
        var i = pageFlip.getCurrentPageIndex();
        if (i === 0 || i === total - 1) stage.style.transform = '';
      } else if (e.data === 'read') {
        center(pageFlip.getCurrentPageIndex());
      }
    });

    function update() {
      var i = pageFlip.getCurrentPageIndex();
      center(i);
      preloadAround(i);
      if (counter) counter.textContent = label(i);
      root.querySelectorAll('[data-fb-prev],[data-fb-first]').forEach(function (b) {
        b.disabled = i === 0;
      });
      var atEnd = i >= total - (pageFlip.getOrientation() === 'landscape' ? 2 : 1);
      root.querySelectorAll('[data-fb-next],[data-fb-last]').forEach(function (b) {
        b.disabled = atEnd;
      });
      if (history.replaceState && (i > 0 || location.hash)) history.replaceState(null, '', '#page/' + (i + 1));
      if (thumbsGrid) {
        thumbsGrid.querySelectorAll('.flipbook__thumb').forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
        });
      }
    }

    window.addEventListener('resize', function () {
      center(pageFlip.getCurrentPageIndex());
    });

    pageFlip.on('flip', update);
    pageFlip.on('changeOrientation', update);
    pageFlip.on('init', update);
    update();

    function bind(sel, fn) {
      root.querySelectorAll(sel).forEach(function (el) {
        el.addEventListener('click', fn);
      });
    }

    function goTo(i) {
      preloadAround(i);
      pageFlip.flip(i);
    }

    bind('[data-fb-prev]', function () {
      pageFlip.flipPrev();
    });
    bind('[data-fb-next]', function () {
      pageFlip.flipNext();
    });
    bind('[data-fb-first]', function () {
      goTo(0);
    });
    bind('[data-fb-last]', function () {
      goTo(total - 1);
    });

    // Sayfa listesi (küçük resimler) ilk açılışta oluşturulur
    bind('[data-fb-thumbs]', function () {
      if (!thumbsPanel) return;
      if (!thumbsGrid.children.length) {
        imgs.forEach(function (img, k) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'flipbook__thumb';
          b.innerHTML =
            '<img loading="lazy" alt="" src="' + (img.dataset.thumb || img.dataset.src) + '"><span>' + (k + 1) + '</span>';
          b.addEventListener('click', function () {
            thumbsPanel.hidden = true;
            // Sayfalar sırayla dönmesin, doğrudan atla
            preloadAround(k);
            pageFlip.turnToPage(k);
            update();
          });
          thumbsGrid.appendChild(b);
        });
        update();
      }
      thumbsPanel.hidden = !thumbsPanel.hidden;
    });

    bind('[data-fb-fullscreen]', function () {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else if (root.requestFullscreen) {
        root.requestFullscreen();
      } else {
        // iOS Safari: Fullscreen API yok, sabit konumla taklit et
        root.classList.toggle('is-fullscreen');
        document.documentElement.style.overflow = root.classList.contains('is-fullscreen') ? 'hidden' : '';
        window.dispatchEvent(new Event('resize'));
      }
    });
    document.addEventListener('fullscreenchange', function () {
      window.dispatchEvent(new Event('resize'));
    });

    // Tüm sayfaları tarayıcıda PDF'e dönüştür (jsPDF sadece tıklanınca yüklenir)
    var pdfBtn = root.querySelector('[data-fb-pdf]');
    if (pdfBtn) {
      var pdfLabel = pdfBtn.querySelector('[data-fb-pdf-label]');
      pdfBtn.addEventListener('click', function () {
        if (pdfBtn.classList.contains('is-busy')) return;
        pdfBtn.classList.add('is-busy');
        var original = pdfLabel.textContent;
        pdfLabel.textContent = 'Hazırlanıyor…';

        var urls = imgs
          .map(function (img) {
            return img.dataset.src;
          })
          .filter(Boolean);

        buildPdf(urls, pdfBtn.dataset.filename || 'katalog.pdf', function (done) {
          pdfLabel.textContent = done + ' / ' + urls.length;
        })
          .catch(function (err) {
            console.error('Flipbook PDF', err);
            alert('PDF oluşturulamadı, lütfen tekrar deneyin.');
          })
          .then(function () {
            pdfBtn.classList.remove('is-busy');
            pdfLabel.textContent = original;
          });
      });
    }

    document.addEventListener('keydown', function (e) {
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
      var r = root.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      if (e.key === 'ArrowLeft') pageFlip.flipPrev();
      else if (e.key === 'ArrowRight') pageFlip.flipNext();
      else if (e.key === 'Escape') {
        if (thumbsPanel) thumbsPanel.hidden = true;
        if (root.classList.contains('is-fullscreen')) {
          root.classList.remove('is-fullscreen');
          document.documentElement.style.overflow = '';
          window.dispatchEvent(new Event('resize'));
        }
      }
    });
  }

  var JSPDF_URL = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.2/dist/jspdf.umd.min.js';
  var jspdfPromise;

  function loadJsPdf() {
    if (window.jspdf) return Promise.resolve(window.jspdf);
    if (!jspdfPromise) {
      jspdfPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = JSPDF_URL;
        s.onload = function () {
          resolve(window.jspdf);
        };
        s.onerror = function () {
          jspdfPromise = null;
          reject(new Error('jsPDF yüklenemedi'));
        };
        document.head.appendChild(s);
      });
    }
    return jspdfPromise;
  }

  // Görseli jsPDF'in kabul ettiği biçime getir: JPEG ise doğrudan, değilse canvas ile JPEG'e çevir
  function fetchPage(url) {
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error(res.status + ' ' + url);
        return res.blob();
      })
      .then(function (blob) {
        if (blob.type === 'image/jpeg') {
          return blob.arrayBuffer().then(function (buf) {
            return new Uint8Array(buf);
          });
        }
        return createImageBitmap(blob).then(function (bmp) {
          var c = document.createElement('canvas');
          c.width = bmp.width;
          c.height = bmp.height;
          var ctx = c.getContext('2d');
          ctx.fillStyle = '#fff';
          ctx.fillRect(0, 0, c.width, c.height);
          ctx.drawImage(bmp, 0, 0);
          return c.toDataURL('image/jpeg', 0.9);
        });
      });
  }

  function buildPdf(urls, filename, onProgress) {
    return loadJsPdf().then(function (lib) {
      // A4 dikey (pt)
      var W = 595.28;
      var H = 841.89;
      var doc = new lib.jsPDF({ unit: 'pt', format: [W, H], orientation: 'portrait', compress: true });
      var done = 0;

      // Sırayı koruyarak 4'erli paralel indir
      var results = new Array(urls.length);
      var next = 0;
      function worker() {
        if (next >= urls.length) return Promise.resolve();
        var i = next++;
        return fetchPage(urls[i]).then(function (data) {
          results[i] = data;
          onProgress(++done);
          return worker();
        });
      }
      var workers = [];
      for (var w = 0; w < Math.min(4, urls.length); w++) workers.push(worker());

      return Promise.all(workers).then(function () {
        results.forEach(function (data, i) {
          if (i > 0) doc.addPage([W, H], 'portrait');
          doc.addImage(data, 'JPEG', 0, 0, W, H, undefined, 'FAST');
        });
        doc.save(filename);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-flipbook]').forEach(initFlipbook);
  }

  // Script'ler defer ile yüklenir; page-flip kütüphanesi önce gelir
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Tema editöründe bölüm yeniden yüklendiğinde
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-flipbook]');
    if (el) initFlipbook(el);
  });
})();
